import {getHostVariables} from './utils';
import {ROOT_NODE} from './symbols';

export default function removeStyles(el) {
	const hostVariables = getHostVariables(el);
	const nodes = [...hostVariables[ROOT_NODE].childNodes];
	const {length: nodeCount} = nodes;

	for (let i = 0; i < nodeCount; i++) {
		const node = nodes[i];
		if (node && (node.tagName === 'STYLE' || node.tagName === 'SCRIPT'))
			hostVariables[ROOT_NODE].removeChild(node);
	}
}
